<template>
	<v-container class="content" fluid>
		<v-snackbar
			v-model="snackbar"
			:timeout="10000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
		<h1>Zertifikatsverwaltung</h1>
		<h2>Auftrag: {{ order.orderId }} vom {{ order.receivedAt | formatDate }}</h2>
		<h2>Liefertermin: {{ order.dueDate | formatDate }}</h2>
		<input
			type="file"
			ref="upload"
			accept=".pdf"
			style="display: none"
			v-on:change="uploadFile($event, $event.target.files)"
		/>
		<v-btn
			@click.stop="$refs.upload.click()"
			:disabled="!order.materialGroups.some((g) => g.positions.some((p) => p.checked))"
			class="mb-2 blexon-button"
			title="Zertifikat für ausgewählte Positionen hochladen."
		>
			<v-icon>upload</v-icon>
		</v-btn>
		<div>
			Zuerst alle Positionen für das gleiche Zertifikat auswählen. Dann Zertifikat hochladen.
		</div>
		<table v-for="material in order.materialGroups" :key="material.materialname">
			<tr>
				<td>
					<v-checkbox
						v-if="material.positions.some((p) => p.certificateId === 0)"
						v-model="material.checked"
						@change="groupCheckedChanged(material)"
					>
					</v-checkbox>
				</td>
				<td colspan="4">
					<h3>{{ material.materialname }}</h3>
				</td>
			</tr>
			<tr v-for="position in material.positions" :key="position.articleId">
				<td></td>
				<td>
					<v-checkbox v-model="position.checked" :disabled="position.certificateId !== 0">
					</v-checkbox>
				</td>
				<td>
					<img
						v-on:load="onImageLoaded($event)"
						v-bind:src="getThumbnailUrl(position.articleId)"
					/>
				</td>
				<td>
					Artikel Id: {{ position.articleId }}<br />
					Zertifikat:
					<span v-if="position.certificateId === 0"> 3.1 </span>
					<span v-else>
						<a href="#" @click="download(position)">3.1</a>
					</span>
				</td>
				<td>
					<v-btn
						:icon="true"
						v-if="position.certificateId > 0"
						title="Zertifikat löschen"
						@click="deleteCertificate(position)"
					>
						<v-icon style="color: #efbb20">delete</v-icon>
					</v-btn>
				</td>
			</tr>
		</table>
	</v-container>
</template>

<script>
import httpClient from "../store/httpClient";

export default {
	components: {},
	data() {
		return {
			dataLoading: false,
			snackbar: false,
			snackbarText: "",
			order: {
				materialGroups: [],
			},
		};
	},

	async mounted() {
		await this.loadOrder();
	},

	methods: {
		async loadOrder() {
			try {
				this.dataLoading = true;
				let response = await httpClient().get(
					`/api/Certificate/GetPositionsWithCertificateRequest?orderId=` +
						this.$route.params.orderId
				);
				this.order = response.data;
			} catch (err) {
				this.setSnackbarText("Fehler beim Laden des Auftrags. ");
			} finally {
				this.dataLoading = false;
			}
		},
		async uploadFile(event, files) {
			if (files.length !== 1) {
				return;
			}
			for (const file of files) {
				const data = new FormData();
				const ids = this.order.materialGroups
					.flatMap((g) => g.positions)
					.filter((p) => p.checked)
					.map((p) => p.articleId);
				data.append("file", file);
				data.append("orderId", this.order.orderId);
				for (var i = 0; i < ids.length; i++) {
					data.append("articleIds[]", ids[i]);
				}
				const config = {
					header: {
						"Content-Type": "multipart/form-data",
					},
				};

				await httpClient().post("api/certificate/UploadCertificate", data, config);
				this.loadOrder();
			}
		},

		async download(position) {
			try {
				var response = await httpClient().post(
					`api/certificate/DownloadCertificate?certificateId=${position.certificateId}`,
					null,
					{
						responseType: "blob",
					}
				);
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute(
					"download",
					`Zertifikat für Artikel ${position.articleId} aus Auftrag ${this.order.orderId}.pdf`
				);
				link.click();
			} catch (err) {
				this.setSnackbarText("Fehler beim Download des Dokuments.");
			} finally {
			}
		},

		async deleteCertificate(position) {
			try {
				this.dataLoading = true;
				await httpClient().delete(
					`/api/Certificate/DeleteCertificate?orderId=${this.$route.params.orderId}&articleId=${position.articleId}`
				);
				this.loadOrder();
			} catch (err) {
				this.setSnackbarText(
					"Fehler beim Löschen des Zertifikats. Bitte wenden Sie sich an unser Helpdesk."
				);
			} finally {
				this.dataLoading = false;
			}
		},

		groupCheckedChanged(group) {
			for (const position of group.positions) {
				if (position.certificateId === 0) {
					position.checked = group.checked;
				}
			}
		},
		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
		getThumbnailUrl(articleId) {
			return process.env.VUE_APP_erpUrl + `article/GetThumbnail?id=${articleId}`;
		},

		/**
		 * Eventhandler when the part image is loaded.
		 * The event contains the image object.
		 * This method sets either the height or width depending on
		 * the aspect ratio of the image.
		 */
		onImageLoaded(event) {
			var height = event.target.height;
			var width = event.target.width;
			if (height > width) {
				event.target.height = 40;
			} else {
				event.target.width = 60;
			}
		},
	},
};
</script>

<style></style>
